import { render, staticRenderFns } from "./SplashCover.vue?vue&type=template&id=77547d39&scoped=true&"
import script from "./SplashCover.vue?vue&type=script&lang=js&"
export * from "./SplashCover.vue?vue&type=script&lang=js&"
import style0 from "./SplashCover.vue?vue&type=style&index=0&id=77547d39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77547d39",
  null
  
)

export default component.exports